import { render, staticRenderFns } from "./form-qualification-education.vue?vue&type=template&id=78ab96bf"
import script from "./form-qualification-education.vue?vue&type=script&lang=js"
export * from "./form-qualification-education.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports